import { useState } from "react";
import api from "../../api/client";

export default function NapEditModal({ record, onClose, onSaved }) {
  const [form, setForm] = useState({
    nap_code: record.nap_code || "",
    no_of_ports: record.no_of_ports ?? "",
    area: record.area || "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError("");
    try {
      const payload = {
        nap_code: form.nap_code.trim() || null,
        no_of_ports: form.no_of_ports !== "" ? parseInt(form.no_of_ports, 10) : null,
        area: form.area.trim() || null,
      };
      await api.put(`/nap-locator/${record.id}`, payload);
      onSaved();
      onClose();
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to update record.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 p-6">
        <h2 className="text-lg font-semibold mb-4">Edit NAP Record</h2>

        <div className="space-y-3">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">NAP Code</label>
            <input
              type="text"
              value={form.nap_code}
              onChange={(e) => handleChange("nap_code", e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">No of Ports</label>
            <input
              type="number"
              value={form.no_of_ports}
              onChange={(e) => handleChange("no_of_ports", e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">LCP Code</label>
            <input
              type="text"
              value={record.lcp_code || ""}
              disabled
              className="w-full px-3 py-2 border border-gray-200 rounded text-sm bg-gray-100 text-gray-500 cursor-not-allowed"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Latitude</label>
              <input
                type="text"
                value={record.latitude ?? ""}
                disabled
                className="w-full px-3 py-2 border border-gray-200 rounded text-sm bg-gray-100 text-gray-500 cursor-not-allowed"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Longitude</label>
              <input
                type="text"
                value={record.longitude ?? ""}
                disabled
                className="w-full px-3 py-2 border border-gray-200 rounded text-sm bg-gray-100 text-gray-500 cursor-not-allowed"
              />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Area</label>
            <input
              type="text"
              value={form.area}
              onChange={(e) => handleChange("area", e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {error && <p className="text-sm text-red-600 mt-3">{error}</p>}

        <div className="flex justify-end gap-2 mt-5">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm border rounded hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={saving || !form.nap_code.trim()}
            className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
